import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(saleAreaId, projectId, department) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
    status: true,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  let searchQueryEmployeeDepartment = new URLSearchParams(
    searchOptions
  ).toString();

  if (department) {
    searchQueryEmployeeDepartment =
      searchQueryParams + "&" + new URLSearchParams({ department }).toString();
  }
  // Fetch constant data concurrently
  const [checkinPlace] = await Promise.all([
    clientAPI("get", `/checkin/place/list?${searchQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    checkinPlace: checkinPlace?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
  };
}

export function useCategories(saleAreaId, projectId, department, shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories31"],
    queryFn: () => fetchConstantData(saleAreaId, projectId, department),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
